import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      // {
      //   color: 'green',
      //   date: {
      //     year: 2018,
      //     month: 12,
      //     day: 16,
      //   },
      // },
      // {
      //   color: 'green',
      //   date: {
      //     year: 2020,
      //     month: 3,
      //     day: 25,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2016,
      //     month: 6,
      //     day: 25,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2017,
      //     month: 6,
      //     day: 1,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2017,
      //     month: 8,
      //     day: 25,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2017,
      //     month: 12,
      //     day: 20,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2019,
      //     month: 6,
      //     day: 1,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2019,
      //     month: 7,
      //     day: 11,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2021,
      //     month: 1,
      //     day: 15,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2021,
      //     month: 3,
      //     day: 2,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2021,
      //     month: 8,
      //     day: 22,
      //   },
      // },
    ],
    IndicePoints: [
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 16,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 25,
        },
      },
      {
        color: 'red',
        date: {
          year: 2016,
          month: 6,
          day: 25,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 6,
          day: 1,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 8,
          day: 25,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 20,
        },
      },
      {
        color: 'red',
        date: {
          year: 2019,
          month: 6,
          day: 1,
        },
      },
      {
        color: 'red',
        date: {
          year: 2019,
          month: 7,
          day: 11,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 1,
          day: 15,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 3,
          day: 2,
        },
      },
      {
        color: 'red',
        date: {
          year: 2019,
          month: 7,
          day: 11,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 1,
          day: 15,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 3,
          day: 2,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 8,
          day: 22,
        },
      },
    ],
  },
};
